import api from '../../services/api';

const baseUrl = 'crm/opportunity/activity'

const edit = async (id, changes) =>
    api.put({ service: `${baseUrl}/${id}`, data: changes });

const editConclusion = async (id, isConcluding, options = {}) =>
    api.put({ service: `${baseUrl}/${id}/edit-conclusion`, data: { isConcluding, ...options } });

export default {
    edit,
    editConclusion
}
